import { openAIConstants } from "../../../../constants/General/openAI.constants";

const initialState = {
    fetching: false,
    listData: null,
    listDataError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {

        case openAIConstants.OPEN_AI_LIST_PENDING:
            return {
                ...state,
                fetching: true,
            };
        case openAIConstants.OPEN_AI_LIST_FULFILLED:
            return {
                ...state,
                fetching: false,
                listDataError: false,
                listData: action.payload,
            };
        case openAIConstants.OPEN_AI_LIST_REJECTED:
            return {
                ...state,
                fetching: false,
                listDataError: action.payload
            };
        case openAIConstants.OPEN_AI_CLEAR:
            return {
                ...state,
                listData: null,
                listDataError: false,
            };
        case "CLEAR_STATE" :
            return {
                ...initialState
            };
        default:
            return state;
    }
}